function chagas(){
	return {
            "games":[
                {
                    "informs":[
                        {
                            "text":"Os hospedeiros intermediários, nos quais ocorre a reprodução assexuada do parasita, podem ser homem ou mamíferos (quati, gambá, tatu e morcego).",
                            "title":"Quem está envolvido no ciclo da doença?",
                            "image":"images/games/informs/chagas/1.png"
                        },
                        {
                            "text":"O hospedeiro definitivo, no qual ocorre a reprodução sexuada do parasita são insetos dos gêneros Triatoma, Panstrongylus, e Rhodnius genericamente chamados de triatomíneos, que também são os vetores da doença.",
                            "title":"Quem está envolvido no ciclo da doença?",
                            "image":"images/games/informs/chagas/1.png"
                        },
                        {
                            "text":"A maioria desses insetos deposita ovos no ambiente, que podem ser transportados por longas distâncias, promovendo sua dispersão.",
                            "title":"Quem está envolvido no ciclo da doença?",
                            "image":"images/games/informs/chagas/1.png"
                        }
                    ],
                    "pathImageGame":"midias/images/games/puzzles/chagas/1.jpg"
                },
                {
                    "informs":[
                        {
                            "text":"Ao se alimentar do sangue do hospedeiro, o barbeiro infectado elimina junto com as fezes, o parasita <i>Trypanosoma cruzi</i> na forma infectante.",
                            "title":"Quem causa a doença?",
                            "image":"images/games/informs/chagas/2.png"
                        },
                        {
                            "text":"Este penetra na pele através de mucosas ou ferimentos e cai na corrente sanguínea. Infecta as células, se desenvolve e se multiplica, rompendo-as, podendo infectar outros tecidos e órgãos.",
                            "title":"Quem causa a doença?",
                            "image":"images/games/informs/chagas/2.png"
                        },
                        {
                            "text":"Quando o barbeiro pica um indivíduo ou animal infectado, os parasitas do sangue destes vão para o intestino do barbeiro e se desenvolvem em formas infectantes.",
                            "title":"Quem causa a doença?",
                            "image":"images/games/informs/chagas/2.png"
                        }
                    ],
                    "pathImageGame":"midias/images/games/puzzles/chagas/2.jpg"
                },
                {
                    "informs":[
                        {
                            "text":"Os sintomas caracterizam-se de acordo com a fase da doença. Na fase aguda (logo após a infecção) pode ocorrer",
                            "title":"Quais os sintomas da doença?",
                            "image":"images/games/informs/chagas/3.png"
                        },
                        {
                            "text":"febre, indisposição, dor de barriga, vômitos, falta de apetite, dores de cabeça e musculares, aparecimento de ínguas e manchas vermelhas na pele.",
                            "title":"Quais os sintomas da doença?",
                            "image":"images/games/informs/chagas/3.png"
                        },
                        {
                            "text":" Na fase crônica podem ocorrer complicações no coração, derrame, aumento de alguns órgãos (fígado, baço, esôfago e/ou intestino), insuficiência cardíaca, tosse, dificuldade para respirar, dor no peito, palpitações, arritmias.",
                            "title":"Quais os sintomas da doença?",
                            "image":"images/games/informs/chagas/3.png"
                        }
                    ],
                    "pathImageGame":"midias/images/games/puzzles/chagas/3.jpg"
                },
                {
        
                    "informs":[
                        {
                            "text":"A doença pode ser adquirida por diferentes vias: vetorial (quando há contato de fezes contaminadas do vetor com ferimento da picada ou mucosas);",
                            "title":"Como a doença é transmitida?",
                            "image":"images/games/informs/chagas/4.png"
                        },
                        {
                            "text":" transfusional (através de sangue contaminado); vertical (de mãe para filho); via oral: ingestão de alimentos contendo o vetor contaminado ou suas fezes, ou reservatórios infectados: sopas, caldo de cana, açaí, bacaba ou carne de caça semicrua;",
                            "title":"Como a doença é transmitida?",
                            "image":"images/games/informs/chagas/4.png"
                        },
                        {
                            "text":"Outras formas menos comuns: via leite materno, acidentes laboratoriais ou transplante de órgãos.",
                            "title":"Como a doença é transmitida?",
                            "image":"images/games/informs/chagas/4.png"
                        }
                    ],
                    "pathImageGame":"midias/images/games/puzzles/chagas/4.jpg"
                },
                {
                    "informs":[
                        {
                            "text":"Como não existe vacina contra a Doença de Chagas, as formas de prevenção visam a eliminação do vetor e a proteção individual.",
                            "title":"Como fazer a prevenção?",
                            "image":"images/games/informs/chagas/5.png"
                        },
                        {
                            "text":"Evitar que o vetor forme colônias nas residências, utilizando inseticidas, mosquiteiros e telas.",
                            "title":"Como fazer a prevenção?",
                            "image":"images/games/informs/chagas/5.png"
                        },
                        {
                            "text":"Durante a realização de atividades noturnas recomenda-se a utilização de repelentes e roupas de mangas longas em áreas de mata.",
                            "title":"Como fazer a prevenção?",
                            "image":"images/games/informs/chagas/5.png"
                        },
                        {
                            "text":"Deve-se priorizar o consumo de alimentos pasteurizados quando estes forem de origem vegetal, como por exemplo, caldo de cana e açaí.",
                            "title":"Como fazer a prevenção?",
                            "image":"images/games/informs/chagas/5.png"
                        }
                    ],
                    "pathImageGame":"midias/images/games/puzzles/chagas/5.jpg"
                }
            ]
        }
    }

    export {chagas};